"use client";
import logoImage from "@rosette/assets/src/logo_text_only.svg";
import Image from "next/image";
import Link from "next/link";
import { cn } from "@rosette/ts/src/util/cn.js";
import { AccountMenuButton } from "@/components/account/AccountMenuButton.js";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import React from "react";


interface HeaderLinkProps {
    href: string;
    pathname: string;
    children?: ReactNode;
}


function HeaderLink({ href, pathname, children }: HeaderLinkProps) {
    return (
        <Link
            className={cn(
                "relative mr-6 text-strong hover:opacity-100",
                "before:absolute before:bottom-0 before:left-0 before:block before:h-[2px] before:w-full",
                "before:origin-top-left before:bg-current before:transition-transform before:duration-200",
                "before:ease-in-out hover:before:scale-x-100",
                (href === pathname ? "opacity-100 before:scale-x-100" : "opacity-80 before:scale-x-0"),
            )}
            href={href}>

            {children}
        </Link>
    );
}


interface HeaderProps {
    className?: string;
}

export default function Header({ className }: HeaderProps) {
    const pathname = usePathname();
    return (
        <header
            className={cn("flex w-full md:px-6", className ?? null)}>

            <div
                className={cn(
                    "grid gap-4 [grid-template-areas:'logo_accounts'_'links_links']",
                    "md:grid-cols-[auto_1fr_auto] md:[grid-template-areas:'logo_links_accounts']",
                    "box-border w-full max-w-7xl mx-auto p-4 text-2xl text-left no-underline [&_a]:no-underline",
                )}>
                <Link className="[grid-area:logo] flex items-center [&_img]:h-[2em] [&_img]:w-auto" href="/">
                    <Image src={logoImage} alt="Logo of RoyalUr.net" priority={true} />
                </Link>
                <div className="[grid-area:links] flex items-center md:p-4">
                    <HeaderLink pathname={pathname} href="/">Home</HeaderLink>
                    <HeaderLink pathname={pathname} href="/rules">Rules</HeaderLink>
                    <HeaderLink pathname={pathname} href="/about">About</HeaderLink>
                    <HeaderLink pathname={pathname} href="/blog">Blog</HeaderLink>
                </div>
                <div className="[grid-area:accounts] flex flex-row-reverse items-center">
                    <AccountMenuButton />
                </div>
            </div>
        </header>
    );
}
